
class _topNews {
  //constructor() {}

  init() {
    if (document.getElementById('c-news__list')) {
      this.newsList = document.querySelectorAll('#c-news__list > li');
      this.limit = 5;
      this.current = this.limit;
      this.max = this.newsList.length;

      this.bindMore = this.more.bind(this);
      this.btnMore = document.getElementById('c-news__more');
      this.btnMore.addEventListener('click', this.bindMore);

      if (this.current >= this.max) {
        this.over();
      }
    }
  }

  start() {

  }

  more() {
    let isOver = false;
    let tmpCurrent = 0;
    for (let i = 0; i < this.limit; i++) {
      tmpCurrent = i + this.current;

      if (!this.newsList[tmpCurrent]) {
        isOver = true;
        break;
      }

      this.newsList[tmpCurrent].classList.add('is-show');
    }

    this.current = tmpCurrent + 1;

    if (isOver || this.current >= this.max) {
      this.over();
    }
  }

  over() {
    this.btnMore.style.display = 'none';
    this.reset();
  }

  reset() {
    if (this.newsList) {
      this.btnMore.removeEventListener('click', this.bindMore);
      this.bindMore = null;
      this.newsList = null;
    }
  }
}

const topNews = new _topNews();

export default topNews;